import React, { useState, useEffect } from 'react';
import { Q } from '../../../../store/student/types';
import { ContinueButton, InputWithConfirm } from 'shared-components';
import { IOtherName } from '../../../../types';

interface IProps {
  index: number;
  givenName: string;
  surname: string;
  reason: string;
  onSaveAndClose: (otherName: IOtherName) => void;
}

const OtherNames = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [givenName, setGivenName] = useState(props.givenName);
  const [surname, setSurname] = useState(props.surname);
  const [reason, setReason] = useState(props.reason);
  const [complete, setComplete] = useState(props.givenName !== '' && props.surname !== '' && props.reason !== '');

  const saveAndClose = () => {
    onSaveAndClose({
      givenName,
      surname,
      reason,
    });
  };

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
    saveAndClose();
  };

  useEffect(() => {
    setComplete(givenName !== '' && surname !== '' && reason !== '');
  }, [givenName, surname, reason]);

  return (
    <>
      <InputWithConfirm
        key={`${Q.GIVEN_NAME}-${index}`}
        id={`${Q.GIVEN_NAME}-${index}`}
        value={givenName}
        label={`First Name`}
        onChange={(evt: any) => setGivenName(evt.currentTarget.value)}
      />

      <InputWithConfirm
        key={`${Q.SURNAME}-${index}`}
        id={`${Q.SURNAME}-${index}`}
        value={surname}
        label={`Family Name`}
        onChange={(evt: any) => setSurname(evt.currentTarget.value)}
      />

      <InputWithConfirm
        key={`${Q.OTHER_NAME_REASON}-${index}`}
        id={`${Q.OTHER_NAME_REASON}-${index}`}
        value={reason}
        label={'Reason for alternative name or name change'}
        onChange={(evt: any) => setReason(evt.currentTarget.value)}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default OtherNames;
